import { Link, useLocation } from 'react-router-dom';
import '../styles/Footer.css';

const FOOTER_LINKS = [
  { type: 'anchor', id: 'beneficios', label: 'Beneficios' },
  { type: 'anchor', id: 'instalaciones', label: 'Instalaciones' },
  { type: 'route', to: '/galeria', label: 'Galería de Modelos' },
  { type: 'anchor', id: 'testimonios', label: 'Testimonios' },
];

function Footer() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const sectionHref = (id) => (isHome ? `#${id}` : `/#${id}`);

  return (
    <footer id="footer" className="tm-footer">
      <div className="tm-container tm-footer-container">
        <div className="tm-footer-grid">
          <div className="tm-footer-brand">
            <div className="tm-footer-logo-container">
              <img
                src={`${process.env.PUBLIC_URL}/logo-tmstudio.png`}
                alt="TM Studio Logo"
                className="tm-footer-logo"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <span className="tm-footer-logo-text">
                <span style={{ color: '#fff' }}>TM</span>
                <span className="gold-gradient-text">Studio</span>
              </span>
            </div>
            <p className="tm-footer-description">
              El estudio líder en gestión de talento para modelos webcam en Cali. Lujo, privacidad y profesionalismo en un solo lugar.
            </p>
            <div className="tm-footer-social">
              <a href="https://wa.me/573215320525" target="_blank" rel="noopener noreferrer" className="tm-footer-social-link" aria-label="WhatsApp" title="WhatsApp">
                <span className="material-symbols-outlined tm-footer-social-icon">chat</span>
              </a>
              <a href="https://www.instagram.com/official_tmodels?igsh=ZnpsdjFrbGczNnZt" target="_blank" rel="noopener noreferrer" className="tm-footer-social-link" aria-label="Instagram" title="Instagram">
                <span className="material-symbols-outlined tm-footer-social-icon">photo_camera</span>
              </a>
              <a href="https://www.tiktok.com/@tmodels.co?_r=1&_t=ZS-93U9h14ek0w" target="_blank" rel="noopener noreferrer" className="tm-footer-social-link" aria-label="TikTok" title="TikTok">
                <span className="material-symbols-outlined tm-footer-social-icon">music_note</span>
              </a>
            </div>
          </div>
          <div>
            <h5 className="tm-footer-section-title">
              Mapa del Sitio
            </h5>
            <ul className="tm-footer-links">
              {FOOTER_LINKS.map((item) => (
                <li key={item.type === 'route' ? item.to : item.id} className="tm-footer-link-item">
                  {item.type === 'route' ? (
                    <Link to={item.to} className="tm-footer-link">{item.label}</Link>
                  ) : (
                    <a href={sectionHref(item.id)} className="tm-footer-link">{item.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h5 className="tm-footer-section-title">
              Contacto
            </h5>
            <ul className="tm-footer-contact">
              <li className="tm-footer-contact-item">
                <span className="material-symbols-outlined tm-footer-contact-icon">mail</span>
                talento@tmstudio.com
              </li>
              <li className="tm-footer-contact-item">
                <span className="material-symbols-outlined tm-footer-contact-icon">call</span>
                321 532 0525
              </li>
              <li className="tm-footer-contact-item">
                <span className="material-symbols-outlined tm-footer-contact-icon">location_on</span>
                <a href="https://maps.app.goo.gl/yaqeTMUQsN3QaGXTA?g_st=aw" target="_blank" rel="noopener noreferrer" className="tm-footer-contact-link">Cali, Colombia – Ver en mapa</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="tm-footer-bottom">
          <p className="tm-footer-copyright">
            © 2024 TM STUDIO CALI. EXCELENCIA Y DISCRECIÓN.
          </p>
          <div className="tm-footer-legal">
            <a href="#footer" className="tm-footer-legal-link">Privacidad</a>
            <a href="#footer" className="tm-footer-legal-link">Términos</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

